export const contactsData = {
    email: 'amar.mau96@gmail.com',
    phone: '+919699262448',
    address: '201, Vidhi Apartment, Near Bharat Petrol Pump, Ulhasnagar - 4',

    sheetAPI: ''
}